import LegalLayout from "../components/LegalLayout";

export default function Terms() {
  return (
    <LegalLayout
      title="Terms of Service"
      overline="LEGAL · TERMS"
      path="/terms"
      description="Terms of service for Martingale Playbook — an educational sports analytics and Martingale strategy tool."
    >
      <p>
        <em>Last updated: February 2026</em>
      </p>
      <h2 className="font-display text-2xl text-white mt-8 mb-3">1. What this service is</h2>
      <p>
        Martingale Playbook (the &ldquo;Service&rdquo;) is an educational and analytical
        tool. We provide AI-generated sports analysis, Martingale progression math, an
        arbitrage scanner, and bet tracking tools. <strong>We do not accept wagers, hold
        funds, or operate a sportsbook.</strong> Any wagering you do occurs on third-party
        licensed sportsbooks under their terms.
      </p>
      <h2 className="font-display text-2xl text-white mt-8 mb-3">2. Eligibility (21+)</h2>
      <p>
        You must be at least 21 years old (or the legal gambling age in your
        jurisdiction, whichever is higher) to create an account or use the Service. Sports
        wagering is not legal in every U.S. state. You are solely responsible for
        confirming legality in your location.
      </p>
      <h2 className="font-display text-2xl text-white mt-8 mb-3">3. No guarantee of outcome</h2>
      <p>
        All picks, win probabilities, and progression plans are <strong>educational
        estimates</strong>. Past performance does not guarantee future results. The
        Martingale system can bust a bankroll quickly; use at your own risk. Never wager
        money you cannot afford to lose.
      </p>
      <h2 className="font-display text-2xl text-white mt-8 mb-3">4. Subscription & billing</h2>
      <p>
        Paid access is $9.99 per week after a 3-day free trial (or 10-day trial via a
        valid referral code). Billing runs through Stripe. Cancel anytime from the Billing
        page; cancellation stops renewal at the end of the current paid week — no refunds
        for partial weeks.
      </p>
      <h2 className="font-display text-2xl text-white mt-8 mb-3">5. Acceptable use</h2>
      <p>
        You agree not to scrape, resell, or rebroadcast our content; not to attempt to
        reverse-engineer the API; and not to use the Service for unlawful activity.
      </p>
      <h2 className="font-display text-2xl text-white mt-8 mb-3">6. Affiliate links</h2>
      <p>
        We may link to third-party sportsbooks (e.g. DraftKings) under their affiliate
        programs. We may earn a commission if you sign up through those links. This does
        not influence our picks.
      </p>
      <h2 className="font-display text-2xl text-white mt-8 mb-3">7. Account termination</h2>
      <p>
        We may suspend or terminate accounts that violate these Terms, that abuse trial
        stacking, or that engage in chargebacks.
      </p>
      <h2 className="font-display text-2xl text-white mt-8 mb-3">8. Limitation of liability</h2>
      <p>
        To the maximum extent permitted by law, the Service is provided &ldquo;as
        is&rdquo; without warranty. We are not liable for gambling losses, missed
        wagers, bookmaker outages, or any indirect, incidental, or consequential damages.
      </p>
      <h2 className="font-display text-2xl text-white mt-8 mb-3">9. Changes</h2>
      <p>
        We may update these Terms. Material changes will be emailed to registered users at
        least 7 days before taking effect.
      </p>
      <h2 className="font-display text-2xl text-white mt-8 mb-3">10. Contact</h2>
      <p>
        Questions? Email us via the <a href="/contact" className="neon-text underline">contact page</a>.
      </p>
    </LegalLayout>
  );
}
